import React, { useEffect, Fragment } from 'react'
import { signOut } from '../../utils/auth/session'
import { AppBar } from '@mui/material'
import { useConfig, Config } from '../../config'
import {
  getUserInfo,
  getCurrentUrl,
  getCookieVal,
  getCookieValueByName,
  setCookie,
  nonSupportedPagesList,
} from '../../utils/helper/helper'

declare global {
  interface Window {
    InitMenu: any
    ShowMorePopup: any
    signout: any
  }
}

window.signout = function signout() {
  localStorage.removeItem('AuthState')
  signOut()
}

function doActAs(userId: number, actAsUserId: number, pageSupported: string) {
  window.InitMenu(userId, actAsUserId, pageSupported, false, true)
}

function checkIfOnlyNavigatingPages(
  userId: number,
  actAsUserId: number,
  pageSupported: string,
) {
  const usernameloggedinuserid = document.getElementsByName(
    'usernameloggedinuserid',
  )
  if (usernameloggedinuserid && usernameloggedinuserid.length > 0) {
    const currentsessionuserid = usernameloggedinuserid[0].innerText.replace(
      'ID: ',
      '',
    )
    if (actAsUserId > 0 && actAsUserId !== parseInt(currentsessionuserid)) {
      doActAs(userId, actAsUserId, pageSupported)
    }
  } else {
    doActAs(userId, actAsUserId, pageSupported)
  }
}

function initActAsMethod(
  userId: number,
  actAsUserId: number,
  pageSupported: string,
  fromClick: boolean,
) {
  // if ( "acting as" ) and from user option click
  if (fromClick && pageSupported !== 'N') {
    doActAs(userId, actAsUserId, pageSupported)
  } else {
    if (pageSupported === 'N') {
      doActAs(userId, actAsUserId, pageSupported)
    } else {
      checkIfOnlyNavigatingPages(userId, actAsUserId, pageSupported)
    }

    //   if (
    //     pageSupported === "N" &&
    //     window.location.pathname !== window.localStorage.getItem("lasturl")
    //   ) {
    //     setTimeout(function () {
    //       window.location.reload();
    //     }, 1000);
    //   }
  }

  window.localStorage.setItem('lasturl', window.location.pathname)
}

function prepareActAsValues(
  UserId: number,
  actAsUserId: number,
  fromClick: boolean,
) {
  const userId = Number(UserId)
  if (fromClick) {
    // do not update act_as_user_id
  } else {
    if (
      getCookieVal('brightmlssubscriber') !== undefined &&
      getCookieVal('brightmlssubscriber') !== null &&
      getCookieVal('brightmlssubscriber') > 0
    ) {
      actAsUserId = getCookieVal('brightmlssubscriber')
    }
  }
  // removes association id from URL
  let pageSupported = 'Y'
  if (nonSupportedPagesList.includes(getCurrentUrl())) {
    pageSupported = 'N'
  }
  // acting as DIFFERENT user and VALID page
  if (actAsUserId > 0 && userId !== actAsUserId && pageSupported === 'Y') {
    initActAsMethod(userId, actAsUserId, 'Y', fromClick)
    return false
  }
  // acting as SAME user
  if (actAsUserId > 0 && userId === actAsUserId) {
    if (fromClick) {
      initActAsMethod(userId, actAsUserId, 'Y', fromClick)
    } else {
      checkIfOnlyNavigatingPages(userId, actAsUserId, 'Y')
    }
    return false
  }
  // acting as DIFFERENT user and INVALID PAGE
  if (actAsUserId > 0 && userId !== actAsUserId && pageSupported === 'N') {
    initActAsMethod(userId, userId, 'N', fromClick)
    return false
  }

  // acting as SAME user and INVALID PAGE
  if (actAsUserId > 0 && userId === actAsUserId && pageSupported === 'N') {
    if (fromClick) {
      initActAsMethod(userId, actAsUserId, 'Y', fromClick)
    } else {
      checkIfOnlyNavigatingPages(userId, actAsUserId, 'Y')
    }
    return false
  }
}

function FireActingAsSwitchMoreEvent(event: any) {
  if (event && event.toElement.defaultValue) {
    const fireEventId = Number(event.toElement.defaultValue)
    return fireEventId
  }
}

async function FireActingAsSwitchEvent(event: any) {
  //get the value of the click event -> done
  if (event.toElement.attributes.id) {
    const fireEventId = Number(event.toElement.attributes.id.value)
    if (fireEventId) {
      const user: any = await getUserInfo()
      prepareActAsValues(
        user && Number(user['custom:MemberMlsId']),
        fireEventId,
        true,
      )
    }
  } else {
    //more modal show
    window.ShowMorePopup()
    setTimeout(() => {
      const anchorLinkSubscribers: any = document.getElementById(
        'actingAsSubscribers',
      )
      const buttonInfo: any = document.getElementsByClassName(
        'ui-widget ui-bn-btn ui-bn-btn-info',
      )
      buttonInfo.forEach((element: any, index: number) => {
        buttonInfo[index].addEventListener('click', () => true)
        buttonInfo[index].click()
      })
      if (anchorLinkSubscribers) {
        const subscriberElement: any = document.getElementsByName('subscriber')
        subscriberElement.forEach((element: any, index: number) => {
          subscriberElement[index].addEventListener(
            'click',
            FireActingAsSwitchMoreEvent,
          )
        })
      }
    }, 1000)
  }
}

function initClickMethod(userId: number) {
  const anchorLinkA: any = document.getElementsByClassName(
    'ActingAsSubscriberChanged',
  )
  // Execute a function when the user releases a key on the keyboard
  if (anchorLinkA && anchorLinkA.length > 0) {
    anchorLinkA.forEach((element: any, index: number) => {
      anchorLinkA[index].addEventListener('click', FireActingAsSwitchEvent)
    })
  }
}

async function loadMenu() {
  const user: any = await getUserInfo()
  let pageSupported = 'Y'
  if (nonSupportedPagesList.includes(getCurrentUrl())) {
    pageSupported = 'N'
  }
  if (user) {
    window.InitMenu(
      Number(user['custom:MemberMlsId']),
      Number(getCookieValueByName('brightmlssubscriber')),
      pageSupported,
      false,
      true,
    )
    setCookie('brightmlsAWSLoggedIn', user['custom:MemberMlsId'], 1)
    setTimeout(() => {
      initClickMethod(Number(user['custom:MemberMlsId']))
    }, 4000)
  }
}

async function loadMegaMenuScript(config: Config) {
  const script = document.createElement('script')
  script.src = `${config.megaMenuUrl}/js/brightmlsmenu.js`
  script.async = true
  script.onload = await loadMenu

  const link = document.createElement('link')
  link.href = `${config.megaMenuUrl}/css/brightmlsmenu.min.css`
  link.type = 'text/css'
  link.rel = 'stylesheet'

  document.getElementsByTagName('head')[0].appendChild(script)
  document.getElementsByTagName('head')[0].appendChild(link)
}

const MegaMenu = () => {
  const { config } = useConfig()

  useEffect(() => {
    if (config) {
      loadMegaMenuScript(config)
    }
  }, [config])

  return (
    <Fragment>
      <AppBar
        position="sticky"
        color="transparent"
        className="appHeaderbarid"
        elevation={4}
        id="authenticatedHeaderId"
      >
        <div id="insertBefore"></div>
      </AppBar>
    </Fragment>
  )
}

export default MegaMenu
